@accounting = require 'accounting'
@moment = require 'moment'
@_ = require 'underscore'
@_s = require 'underscore.string'
@filterLabelMap = require '../components/filter2/dropdown/label_map.coffee'
